import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import About from "../pages/About/About";
import History from "../pages/History/History";
import Home from "../pages/Home/Home";
import Login from "../pages/Login/Login";
import Machine from "../pages/Machine/Machine";
import PaymentPolicy from "../pages/PaymentPolicy/PaymentPolicy";
import Policy from "../pages/Policy/Policy";
import Promotion from "../pages/Promotion/Promotion";
import Term from "../pages/Term_Condition/Term";
import Wallets from "../pages/Wallets/Wallets";

const Router = () => {
  return (
    <div>
      <BrowserRouter>
        <Switch>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/home" component={Home} />
            <Route exact path="/machine" component={Machine} />
            <Route exact path="/policy" component={Policy} />
            <Route exact path="/condition" component={Term} />
            <Route exact path="/wallets" component={Wallets} />
            <Route exact path="/history" component={History} />
            <Route exact path="/about" component={About} />
            <Route exact path="/promotion" component={Promotion} />
            <Route exact path="/payment_policy" component={PaymentPolicy} />
          </Switch>
        </Switch>
      </BrowserRouter>
    </div>
  );
};

export default Router;
